import constants from '../constants/index';

const MeetingActions = {
	requestMeetingsSuccess: function(meetings) {
		return {
			type: constants.REQUEST_MEETINGS_SUCCESS,
			payload: {
				meetings: meetings
			}
		};
	},

	requestScheduledMeetingsSuccess: function(scheduledMeetings) {
		return (publish, clients) => {
			publish({
				type: constants.REQUEST_SCHEDULED_MEETINGS_SUCCESS,
				payload: {
					scheduledMeetings
				}
			});
		};
	},

	changeMeetingNames: function(selectedMeetings, meeting_id, params) {
		return (publish, clients) => {
			let cells = [];
			let values = [];
			publish({
				type: constants.CHANGE_SCHEDULED_MEETING_NAMES,
				payload: {
					ids: selectedMeetings.map(meeting => meeting.id),
					meeting_id: meeting_id
				}
			});

			selectedMeetings.forEach(meeting => {
				cells = cells.concat(meeting.sheet_references);
				values.push(meeting_id);
			});
			
			// Not actually persisting updates right now, but uncomment
			// the following line to see what would be updated in the 
			// spreadsheet if we were:
			// console.log("Updating Spreadsheet", cells, values);
		};
	},

	updateMeetingSuccess: function(response) {
		console.log(response);
	},

	updateMeetingFail: function(err) {
		console.log(err);
	}
};

export default MeetingActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/meeting_actions.js
 **/